import { Utilities as utilities } from '@truckdown/framework';

export class LogEntryExceptionModel {
    constructor(json?: any) {
        if (json) {
            this.message = utilities.json.getStringValue(json, 'msg', '');
            this.source = utilities.json.getStringValue(json, 's', '');
            this.stackTrace = utilities.json.getStringValue(json, 'st', '');
            this.targetSite = utilities.json.getStringValue(json, 'ts');
            this.helpLink = utilities.json.getStringValue(json, 'hl');
            if (json.hasOwnProperty('innerException') && json['innerException'] && json['innerException'] !== null) {
                this.innerException = new LogEntryExceptionModel(json['innerException']);
            }
        }
    }

    message: string = '';
    source: string = '';
    stackTrace: string = '';
    targetSite: string | null = null;
    helpLink: string | null = null;
    innerException: LogEntryExceptionModel | null = null;
}